module.exports = __webpack_public_path__ + "img/result-detail-invest-title.ee90e0e2.svg";